import { useState } from 'react';

import { Form, Input, Row, Col, Card, Select, Button, Spin } from 'antd';

import { optionSearchFunction } from '@/utils/common';

import { handlePostApi } from '@/api/crud';
import { subscribeApiEndpoints, customerApiEndpoints } from '@/api/endpoints';
import { Heading } from '@/components';

import { rules } from '@/utils/validation/FormValidation';
import { useFetch } from '@/hooks';

import DateField from '@/utils/date/Date';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import { useNavigate } from 'react-router-dom';

const CreateSubscriptionForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  // version
  const versionOption = [
    {
      value: '1',
      label: '1',
    },
    {
      value: '2',
      label: '2',
    },
    {
      value: '3',
      label: '3',
    },
  ];
  return (
    <>
      <Spin spinning={loading}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            className="username"
            labelCol={{
              span: 12,
            }}
            wrapperCol={{
              span: 24,
            }}
            onFinish={(value) =>
              handlePostApi(
                subscribeApiEndpoints.create,
                {
                  ...value,
                  expiryDate: value.expiryDate,
                },
                setLoading,
                form,
              )
            }
          >
            <GlobalDivider name="Subscription" />

            <Row gutter={[16, 16]}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  name="version"
                  label="Version"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    placeholder="Select Version"
                    options={versionOption}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  name="noOfCompany"
                  label="No of Company"
                  rules={rules.numberOnly}
                  hasFeedback
                >
                  <Input placeholder="No of Company" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  name="noOfBranch"
                  label="No of Branch"
                  rules={rules.numberOnly}
                  hasFeedback
                >
                  <Input placeholder="Number of Branch" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  name="noOfUser"
                  label="No of users"
                  rules={rules.numberOnly}
                  hasFeedback
                >
                  <Input placeholder="No of users" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  name="startDate"
                  label="Start Date"
                  rules={rules.Date}
                >
                  <DateField />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  name="expiryDate"
                  label="Expiry Date"
                  rules={rules.Date}
                >
                  <DateField />
                </Form.Item>
              </Col>

              {/* <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  name="mobileNumber"
                  label="Mobile"
                  rules={rules.phoneNumber}
                  hasFeedback
                >
                  <Input type="tel" placeholder="Mobile" maxLength={10} />
                </Form.Item>
              </Col> */}
            </Row>

            <div className="flex justify-end">
              <div className="flex gap-2">
                <Button type="primary" htmlType="submit">
                  Create
                </Button>
                <Button
                  className="auto-danger-btn"
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </Spin>
    </>
  );
};

export default CreateSubscriptionForm;
